/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes, {pageRoutes} from './modules/index';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar styles
import Cookies from 'js-cookie';
import store from '../store'


Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 路由拦截
const whiteList = ['/login'];
router.beforeEach((to, from, next) => {
  NProgress.start();
  const cookie = Cookies.get('cmsweb');
  if (cookie) {
    if (!store.state.user.routeRole) {
      store.dispatch('getUserInfo').then((res) => {
        window.location.reload();
      })
    } else {
      if (whiteList.includes(to.path)) next({name: 'Home'});
      else next();
    }
  } else {
    if (whiteList.includes(to.path)) next();
    else next({name: 'login'});
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
})

export default router;
